import _ from 'lodash';
import React from 'react';

import {connect} from 'react-redux';

import {fetchLookerRevenueUrl, selectLookerRevenueUrl} from 'ducks/reporting';

class EmbeddedLookerDashboard extends React.Component<any> {
  componentDidMount() {
    this.fetchLookerRevenueUrl();
  }

  fetchLookerRevenueUrl = () => {
    const {locationRef} = this.props;
    this.props.fetchLookerRevenueUrl({locationRef});
  };
  render() {
    return (
      <iframe
        style={{
          width: 'calc(100vw - 21.5rem)',
          height: 'calc(100vh - 6.5rem)',
          overflow: 'visible'
        }}
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        ref="iframe"
        title="lookerRevenueDashboard"
        src={this.props.LookerUrl.url}
        scrolling="no"
        frameBorder="0"
      />
    );
  }
}

const mapStateToProps = state => ({
  LookerUrl: selectLookerRevenueUrl(state)
});

const mapDispatchToProps = {fetchLookerRevenueUrl};
export default connect(mapStateToProps, mapDispatchToProps)(
  EmbeddedLookerDashboard
);
